import { create } from "zustand";

export const DEFAULT_SEARCH = {
    keyword: "",
    jobCategory: [],
    city: "",
    zip: "",
    distance: "",
    frequency:[],
    rates: {
        min: 0,
        max: 60,
    },
    workExperience:"",
    childNumber:[],
    childYears:[],
    candidateYears:[],
    withinWeek: "",
    withinMonth: "",
    carOrLicence: "",
    thisWeek:"",
    backgroundStatus: "",
    workingAbroad: "",
    childSocialNeed: "",
    newbornExperience: "",
    tutorClasses:[],
};

export const searchStore = create((set) => ({
    filter: JSON.parse(localStorage.getItem("filter")) || {},
    search: structuredClone(DEFAULT_SEARCH),
    setSearch: (newSearch) =>
        set((state) => ({ search: { ...state.search, ...newSearch } })),
    localSearch: structuredClone(DEFAULT_SEARCH),
    previousLocation: "",
    setPreviousLocation: (newValue) => set({ previousLocation: newValue }),
    sortBy: "Relevance",
    setSortBy: (newValue) => set({ sortBy: newValue }),
    setLocalSearch: (newSearch) =>
        set((state) => ({ localSearch: { ...state.localSearch, ...newSearch } })),
    resetSearch: () => set({ search: structuredClone(DEFAULT_SEARCH) }),
    resetLocalSearch: () => set({ localSearch: structuredClone(DEFAULT_SEARCH) }),
    latitude: 0,
    setLatitude: (newValue) => set({ latitude: newValue }),
    longitude: 0,
    setLongitude: (newValue) => set({ longitude: newValue }),


}));
